import { theme } from '@/config'
import { View } from '@/components'
import { PropsOf } from '@codeleap/types'
import { IconCircle } from './IconCircle'

export type LoadingProps = PropsOf<typeof View> & {
  size?: number
}

export function Loading({ size = 46, ...props }: LoadingProps) {
  return (
    <View
      {...props}
      animated
      animate={{ rotate: 360 }}
      transition={{ repeat: Infinity, duration: 2, ease: 'linear' }}
      style={{ display: 'inline-block' }}
    >
      <IconCircle
        icon={'loading-02'}
        size={size}
        bgCircle={theme.baseColors.primarySolid50}
        bgIcon={theme.baseColors.primaryTransparent200}
        color={theme.baseColors.primarySolid300}
      />
    </View>
  )
}
